import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { BUOY_TYPES, MEDLEM_ID_PATTERN, NODE_ID_PATTERN } from '../../../../utils';

const scrollTop = () => {
  setTimeout(() => {
    window.scrollTo(0, 0);
  });
};

const MAX_SUMMARY_LENGTH = 375;

function makeSummary(text?: string): string {
  if (!text) {
    return '';
  }

  const fragment = document.createElement('div');
  fragment.innerHTML = text;
  return (fragment.textContent || fragment.innerText || '').substring(0, MAX_SUMMARY_LENGTH);
}

interface ListItemProps {
  id: string;
  type: string;
  typeName: string;
  organizationId?: number;
  organization?: string;
  name: string;
  description: string;
  latitude: number;
  longitude: number;
  position: string;
  image?: string;
  chartNumber?: number;
  boatGateCode?: string;
  style?: unknown;
}

export default function ListItem({
  id,
  image,
  name,
  type,
  description,
  position,
  latitude,
  longitude,
  chartNumber,
  boatGateCode,
  organization,
}: ListItemProps): ReactElement {
  const mapUrl = `/sjokort/${latitude},${longitude},17`;
  return (
    <div className="ts-activity-item-row">
      <div className={`ts-activity-item-row-content ${image ? 'has-image' : ''}`}>
        <div className="ts-activity-item-row-title">
          <Link to={mapUrl} onClick={scrollTop}>
            {name}
          </Link>
        </div>
        <div className="ts-activity-item-row-text">{makeSummary(description)}</div>
        {boatGateCode ? (
          <div className="item-info">
            <strong>Båtportskod</strong> {boatGateCode || '-'}
          </div>
        ) : null}
        {chartNumber ? (
          <div className="item-info">
            <strong>Sjökortsnummer</strong> {chartNumber || '-'}
          </div>
        ) : null}
        {organization ? (
          <div className="item-info">
            <strong>Krets</strong> {organization}
          </div>
        ) : null}
        <div className="ts-activity-item-row-footer clearfix">
          <span className="icon-coordinates">{position}</span>
          <div className="node-list-row-link">
            {NODE_ID_PATTERN.test(id) && (
              <span>
                <a href={`/node/${id.substring(1)}`}>Visa hela</a> -{' '}
              </span>
            )}
            {MEDLEM_ID_PATTERN.test(id) && (
              <span>
                <Link to={`/sjokort/${id}`} onClick={scrollTop}>
                  Visa hela
                </Link>{' '}
                -{' '}
              </span>
            )}
            <Link to={mapUrl} onClick={scrollTop}>
              Visa på sjökort
            </Link>
          </div>
        </div>
      </div>
      {image && (
        <div className="ts-activity-item-row-image" style={{ backgroundImage: `url('${image}')` }}>
          {NODE_ID_PATTERN.test(id) && <a href={`/node/${id.substring(1)}`} />}
          {MEDLEM_ID_PATTERN.test(id) && <Link to={`/sjokort/${id}`} onClick={scrollTop} />}
        </div>
      )}
    </div>
  );
}
